/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespTopHeroBannerModule_componentModule = {
    readonly title: string | null;
    readonly items: ReadonlyArray<{
        readonly cmsId: number | null;
        readonly imageUrl?: string | null;
        readonly imageHeight?: string | null;
        readonly imageWidth?: string | null;
        readonly mobileImageHeight?: string | null;
        readonly mobileImageWidth?: string | null;
        readonly mobileImageUrl?: string | null;
        readonly linkData: {
            readonly path: string | null;
        };
        readonly imageCopy: string | null;
        readonly cta: string | null;
        readonly isFullBleedImage: boolean | null;
    } | null> | null;
    readonly " $refType": "HpRespTopHeroBannerModule_componentModule";
};
export type HpRespTopHeroBannerModule_componentModule$data = HpRespTopHeroBannerModule_componentModule;
export type HpRespTopHeroBannerModule_componentModule$key = {
    readonly " $data"?: HpRespTopHeroBannerModule_componentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespTopHeroBannerModule_componentModule">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "HpRespTopHeroBannerModule_componentModule",
  "type": "TopHeroBannerModule",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMobile",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "items",
      "storageKey": null,
      "args": null,
      "concreteType": "TopHeroBannerItem",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "cmsId",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "linkData",
          "storageKey": null,
          "args": null,
          "concreteType": "LinkData",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "path",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "imageCopy",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "cta",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isFullBleedImage",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "Condition",
          "passingValue": false,
          "condition": "isMobile",
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "imageUrl",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "imageHeight",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "imageWidth",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "Condition",
          "passingValue": true,
          "condition": "isMobile",
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "mobileImageHeight",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "mobileImageWidth",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "mobileImageUrl",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '151178cf34bfa2eb432a42cd2be98409';
export default node;
